/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Meal_DinnerInputs */

const en_for_whom_meal_dinner = /** @type {(inputs: For_Whom_Meal_DinnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dinner`)
};

const pl_for_whom_meal_dinner = /** @type {(inputs: For_Whom_Meal_DinnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolacja`)
};

/**
* | output |
* | --- |
* | "Dinner" |
*
* @param {For_Whom_Meal_DinnerInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_meal_dinner = /** @type {((inputs?: For_Whom_Meal_DinnerInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Meal_DinnerInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_meal_dinner(inputs)
	return en_for_whom_meal_dinner(inputs)
});